export default __webpack_public_path__ + "static/media/location.942bb3fa.webp";